import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../../../lib/api';

export const useGetTileDigestAutomator = () => {
  return useQuery(['updateAutomator'], () =>
    get('/api/client_admin/send/tiles_digest_automators/'),
  );
};

export const updateTilesDigestAutomator = ({
  tilesDigestAutomator,
  tilesDigestAutomatorId,
}) => {
  return api.put(
    `/api/client_admin/send/tiles_digest_automators/${tilesDigestAutomatorId}`,
    {
      tiles_digest_automator: {
        day: tilesDigestAutomator.day,
        time: tilesDigestAutomator.time,
        frequency_cd: tilesDigestAutomator.frequencyCd,
        has_follow_up: tilesDigestAutomator.hasFollowUp,
        include_sms: tilesDigestAutomator.includeSms,
        include_unclaimed_users: !tilesDigestAutomator.activeUsers,
        demo_id: tilesDigestAutomator.demoId,
      },
    },
  );
};

export const deleteTilesDigestAutomator = tilesDigestAutomator => {
  return api({
    method: 'delete',
    url: `/api/client_admin/send/tiles_digest_automators/${tilesDigestAutomator.id}`,
    data: {
      tiles_digest_automator: {
        demo_id: tilesDigestAutomator.demoId,
      },
    },
  });
};
